import React from "react";
import StandardInstruction from "../StandardInstruction";

function PathBuilderInstructionsKeyBackup({ t, options }) {
  if (!options.backupSeedSeedor) return null;

  return (
    <div id="key-backup-section" className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.keyBackup")}</h3>
      <StandardInstruction
        title={t("pathBuilder.instructionTitles.backupSeedSeedor")}
        icon="🔨"
        intro={t("pathBuilder.instructionContent.backupSeedSeedorIntro")}
        tools={{
          items: [
            t("pathBuilder.instructionContent.backupSeedSeedorTool1"),
            t("pathBuilder.instructionContent.backupSeedSeedorTool2"),
            t("pathBuilder.instructionContent.backupSeedSeedorTool3"),
          ],
        }}
        steps={{
          items: [
            t("pathBuilder.instructionContent.backupSeedSeedorStep1"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep2"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep3"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep4"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep5"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep6"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep7"),
            t("pathBuilder.instructionContent.backupSeedSeedorStep8"),
          ],
        }}
        note={{
          label: t("pathBuilder.instructionContent.importantNote"),
          text: t("pathBuilder.instructionContent.backupSeedSeedorNote"),
        }}
      />
    </div>
  );
}

export default PathBuilderInstructionsKeyBackup;
